export default {
  passwordConfirmation: 'Passwords must match',
};
